module.exports = function(app) {

	app.controller('pages.forgotPassword.step3', ["$state", "$scope", "$http", "coremetrics", "userService", function($state, $scope, $http, coremetrics, userService) {

        $scope.showOkButton = false;

        var phoneNumber = "1-877-298-3918";
        if ($scope.brandData.phoneNumbers && $scope.brandData.phoneNumbers.technical) {
            phoneNumber = $scope.brandData.phoneNumbers.technical;
        }

        $scope.footerMessage = {
            header: "",
            message: "",
            iconClass: "",
            show: false
        };

        $scope.sidebar = {
			heading: "Request Lost Information",
			description: "Some intro text here around what to expect in the process and all."
		};

        $scope.cancelButton = function() {
            // console.debug("Cancel");
            window.scrollTo(0,0);
            $scope.$parent.payload = "";            
            //$scope.$parent.myChevron.state = "forgotPassword.step1";
            //$scope.$parent.myChevron.step = 1;
            $scope.$parent.goto(1);
        };

        $scope.sendToStep2 = function() {
            window.scrollTo(0,0);
            //$scope.$parent.myChevron.state = "forgotPassword.step2";
            //$scope.$parent.myChevron.step = 2;
            $scope.$parent.goto(2);
        };

        $scope.user = {
            loginOrPassword: "",
            checkScreenValid: ($scope.$parent.payload) ? (($scope.$parent.verificationSuccess)? true: $scope.sendToStep2()) : $scope.cancelButton()
        };

        $scope.nextStep = function(screen) {
            //validate
            if ($scope.user.loginOrPassword != '') {

                $scope.disabledButton = true;
                //editPayload
                var payload = $scope.$parent.payload;
                payload.payload.reset = $scope.user.loginOrPassword;
                $scope.$parent.payload = payload;

                //call service
                $http({
                    url: "/rbsmbl/x-services/user/forgottenUsernamePassword",
                    method: "POST",
                    data: $scope.$parent.payload

                }).then(function (response) {
                    $scope.disabledButton = false;

                    // Finish step 3 conversion event
                    coremetrics.finishConversion('STEP 3 SELECT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

                    //display modal
                    if ($scope.user.loginOrPassword == 'login') {
                        userService.showFooterMessage($scope.footerMessage, "<span data-aem-content='HOM_ForgotPwd_Modal_UsernameSuccess as content'>{{content.header}}</span>", "<span data-aem-content='HOM_ForgotPwd_Modal_UsernameSuccess as content'>{{content.bottomText}}</span>", false);

                    } else {
                        userService.showFooterMessage($scope.footerMessage, "<span data-aem-content='HOM_ForgotPwd_Modal_PasswordSuccess as content'>{{content.header}}</span>", "<span data-aem-content='HOM_ForgotPwd_Modal_PasswordSuccess as content'>{{content.bottomText}}</span>", false);
                    }
                    $scope.showOkButton = true;
                    window.scrollTo(0,0);

                }, function (error) {
                    //console.debug('error', error);
                    $scope.disabledButton = false;

                    if (error.data.baseMessage.returnCodeDescription === 'GEN-SUSPEND') {
                        userService.showFooterMessage($scope.footerMessage, "WE HAVE TO SUSPEND YOUR ONLINE ACCESS",
                                                      "For security reasons we have to suspend your online access. For help, call " + phoneNumber, true);

                    } else if (error.data.baseMessage.returnCodeDescription === 'GEN-NOMATCHFORGOTTEN') {
                        userService.showFooterMessage($scope.footerMessage, "NO MATCH", "Your entry does not match our records.", true);

                    } else {
                        userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                            "If the problem continues, please call the number on the back of your member ID card.", true);
                    }
                    window.scrollTo(0,0);
                });
            }
        };

        $scope.okButton = function() {
            // Finish whole flow conversion event
            coremetrics.finishConversion('FORGOT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

            location.replace("/home/");
        };

        // Start step 3 conversion event
        coremetrics.startConversion('STEP 3 SELECT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

	}]);
};